module.exports = __webpack_public_path__ + "img/permisson-comparison2.66ad0205.jpg";